import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import MppModal from "../../component/MppModal/MppModal";
import Services from "../../services/Services";
import configuration from "../../configuration/configuration";
import { generateGALinkerId, populateSyfTokenCookie, getUpdatedFlow, getDeviceType } from "./Utils";
import queryString from "query-string";
import { debounce } from "lodash";
import MSFJumpScreen from "../../component/MppModal/MSFJumpScreen";
import MppModalHeader from "../../component/MppModal/MppModalHeader";
import services from "../../services/Services";

export const ThemeContext = React.createContext();

class MppInfo extends Component {
  wrapperRef = React.createRef();

  state = {
    isWideWrapper: false,
    offers: [],
    brandings: [],
    title: "Offers to finance this purchase of $1000",
    totalAmount: "",
    isCheckoutDataApiFailed: false,
    isWebviewTokenValidationFailed: false,
    isMerchantApiFailed: false,
    syfToken: "",
    isSpinnerDisplayed: "none",
    showMsfFlag: true,
    applyPrequalPendingStatus: "",
    isPrequalified: true,
    partnerId: "",
    flowType: "",
    fromEmail:"",
    productCategoryNames1: "",
    productCategoryNames2: "",
    productCategoryNames3: "",
    productIds1: "",
    productIds2: "",
    productIds3: "",
    syfMerchantNumber : "",
    channelId :"",
    transAmount1: "",
    transAmount2: "",
    transAmount3: "",
    url: "",
    setPayIn4Info: {},
    merchantNumber: "",
    merchantWebsiteURL: "",
    showMppAmountInputBox: "",
    min: "",
    max: "",
    isFocused: false,
    isAmountEntryReadonly: false,
    footerLinkColor: "",
    isToolTip: "",
    toolTipContent: "",
    amount: "",
    mppFromEmail: false,
    merchantName: "",
    empqPaylaterMonthlyFlag: "N",
    isDataShareTokenAvailable: false,
    isSetPayIn4Alone: false,
    isMsfApplyBuyFlow: false,
    mppFromAnyWhereFlag: "",
    adobe_mcvid : '',
    industryName: "",
    initialCallCompleted: "",
    clientCode: "",
    acquisitionFlag: "",
    applyFromAnyWhereFlag: "",
    payInFourProductConfigured: false,
  };
  async componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const partnerId = query.get("partnerId");
    const amount = query.get("amount");
    const childMid = query.get("childMid");
    const isMpqReturnReq = query.get("isMpqReturnReq");
    const flowType = query.get("flowType");
    const productCategoryNames = query.get("productCategoryNames");
    const productCategoryNames1 = query.get("productCategoryNames1");
    const productCategoryNames2 = query.get("productCategoryNames2");
    const productCategoryNames3 = query.get("productCategoryNames3");
    const syfMerchantNumber = query.get('syfMerchantNumber')
    const channelId = query.get('channelId')
    const transAmount1 = query.get("transAmount1");
    const transAmount2 = query.get("transAmount2");
    const transAmount3 = query.get("transAmount3");
    const promoOverRideFlag = query.get("promoOverRideFlag");
    const offerNumber1 = query.get("offerNumber1");
    const offerNumber2 = query.get("offerNumber2");
    const offerNumber3 = query.get("offerNumber3");
    const storeMid = query.get("storeMid");
    const url = query.get("url");
    var syfToken = query.get("syfToken");
    var mppFromAnyWhereFlag = query.get("mppFromAnyWhereFlag");
    var fromEmail = query.get("fromEmail");
    var sc = query.get("sc");
    const tags = query.get("tag");
    var widgetWebviewFlag = query.get("widgetWebviewFlag");
    const queryValues = queryString.parse(this.props.location.search);
    const tokenId = query.get("tokenId");
    const transactionToken = query.get("transactionToken")

    const passedJson = query.get("passedJson");
    let productIds1 = query.get("productIds1") || "";
    let productIds2 = query.get("productIds2") || "";
    let productIds3 = query.get("productIds3") || "";
    
    if (passedJson) {
      try {
        const parsedPassedJson = JSON.parse(passedJson);
        if (!productIds1) productIds1 = parsedPassedJson?.productIds1 || "";
        if (!productIds2) productIds2 = parsedPassedJson?.productIds2 || "";
        if (!productIds3) productIds3 = parsedPassedJson?.productIds3 || "";
      } catch (error) {
        console.error("error parsing passedJson for productIds", error);
      }
    }

    const merchantPrice = ["", "0"].includes(amount)
      ? amount
      : amount && parseFloat(amount).toFixed(2);
    const originUrl = document.referrer;
    let isMsfApplyBuyFlow = query.get("isMsfApplyBuyFlow");
    const adobe_mcvid = query.get("adobe_mcvid");
    if(adobe_mcvid) this.safeSetItem("adobe_mcvid", adobe_mcvid)

    const { childSyfPartnerId, partnerCode, childSyfMerchantNumber, d2dFlow, partnerProfileCode, merchantRefererUrl, processInd, siteCode, clientTransId, clientName, 
      mppApplicationLink, authorizationNumber,isQuickScreenDeclined, fromWebview, webviewAccessToken, d2dFlowType, isCheckoutLearnClicked
    } = queryValues;
    const stripeFlow = query.get("stripeFlow");

    var acquisitionFlag = query.get("acquisitionFlag");
    var applyFromAnyWhereFlag = query.get("applyFromAnyWhereFlag");

    const orgFlow = getOrgFlow(flowType, d2dFlow, mppFromAnyWhereFlag, isCheckoutLearnClicked,fromEmail,sc,authorizationNumber,isQuickScreenDeclined,amount,applyFromAnyWhereFlag, undefined, stripeFlow);
    this.setState({
      isPrequalified: true,
      partnerId,
      flowType,
      fromEmail,
      syfToken,
      url,
      queryValues,
      amount,
      productCategoryNames,
      productCategoryNames1,
      productCategoryNames2,
      productCategoryNames3,
      productIds1,
      productIds2,
      productIds3,
      syfMerchantNumber,
      channelId,
      transAmount1,
      transAmount2,
      transAmount3,
      childMid,
      promoOverRideFlag,
      offerNumber1,
      offerNumber2,
      offerNumber3,
      storeMid,
      tokenId,
      transactionToken,
      originUrl,
      isMsfApplyBuyFlow,
      mppFromAnyWhereFlag,
      orgFlow,
      adobe_mcvid,
      isCheckoutLearnClicked,
      sc,
      isQuickScreenDeclined,
      acquisitionFlag,
      applyFromAnyWhereFlag
    });

    if (isMpqReturnReq || "true" == isMpqReturnReq) {
      this.redirectToMpq();
    }
    else if (fromEmail === "Y" || sc === "QR") {
      const isEmailFlow = fromEmail === "Y";
      syfToken = await populateSyfTokenCookie(partnerId);
      const flowTypeForMppAnywhere = "PDP";
      fromEmail = "Y";
      this.setState({ flowType: flowTypeForMppAnywhere, syfToken: syfToken, mppFromEmail: true, productCategoryNames: tags });
      this.getMerchantDetails(
        processInd,
        partnerId,
        amount == null ? "" : amount,
        tags,
        "",
        "",
        "",
        amount == null ? "" : amount,
        "",
        "",
        syfToken, flowTypeForMppAnywhere,
        isEmailFlow ? "Y" : "", "", "", "", promoOverRideFlag,
        "","","","","","","",
        "","","","","","","",
        "",webviewAccessToken,syfMerchantNumber,channelId,orgFlow,acquisitionFlag,applyFromAnyWhereFlag,adobe_mcvid,this.state.payInFourProductConfigured,originUrl,
        productIds1,productIds2,productIds3
      )
    }
    else if(fromWebview === "Y"){
      syfToken = await populateSyfTokenCookie(partnerId);
      const flowTypeForMppAnywhere = "PDP";
      this.setState({ flowType: flowTypeForMppAnywhere, syfToken: syfToken, productCategoryNames: tags });
      this.getMerchantDetails(
        processInd,
        partnerId,
        amount == null ? "" : amount,
        tags,
        "",
        "",
        "",
        amount == null ? "" : amount,
        "",
        "",
        syfToken, flowTypeForMppAnywhere,
        "", "", "", "", promoOverRideFlag,
        "","","","","","","",
        "","","","","","","",
        widgetWebviewFlag="Y",
        webviewAccessToken,
        syfMerchantNumber,channelId, orgFlow,acquisitionFlag,applyFromAnyWhereFlag,adobe_mcvid,this.state.payInFourProductConfigured,originUrl,
        productIds1,productIds2,productIds3
      )
    }
    else {
      this.getMerchantDetails(
        processInd,
        partnerId,
        merchantPrice,
        productCategoryNames,
        productCategoryNames1,
        productCategoryNames2,
        productCategoryNames3,
        transAmount1,
        transAmount2,
        transAmount3,
        syfToken,
        flowType,
        mppFromAnyWhereFlag,
        childSyfPartnerId,
        partnerCode,
        childSyfMerchantNumber,
        promoOverRideFlag,
        offerNumber1,
        offerNumber2,
        offerNumber3,
        tokenId,
        transactionToken,
        d2dFlow,
        merchantRefererUrl,
        partnerProfileCode,
        siteCode,
        clientTransId,
        clientName,
        mppApplicationLink,
        authorizationNumber,
        "",
        widgetWebviewFlag,
        webviewAccessToken,
        syfMerchantNumber,
        channelId,
        orgFlow,
        acquisitionFlag,
        applyFromAnyWhereFlag,
        adobe_mcvid,
        this.state.payInFourProductConfigured,
        originUrl,
        productIds1,
        productIds2,
        productIds3
      );
    }

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty(
        "--screen-height",
        window.innerHeight + "px"
      );
      let resizevh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${resizevh}px`);
    });

    if (this.wrapperRef.current) {
      this.setState({ isWideWrapper: this.wrapperRef.current.getBoundingClientRect().width > 700 });
      this.wrapperResizeObserver = new ResizeObserver(([entry]) => {
        this.setState({ isWideWrapper: entry.contentRect.width > 700 });
      });
      this.wrapperResizeObserver.observe(this.wrapperRef.current);
    }
  }

  componentWillUnmount() {
    this.wrapperResizeObserver?.disconnect();
  }

  // Safe wrapper for window.localStorage.getItem()
  safeGetItem = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  // Safe wrapper for direct localStorage.getItem() - for direct scope usage
  safeGetItemDirect = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  // Safe wrapper for window.localStorage.setItem()
  safeSetItem = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.warn(`Failed to set localStorage item: ${key}`, e);
    }
  }

  // Safe wrapper for direct localStorage.setItem() - for direct scope usage
  safeSetItemDirect = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn(`Failed to set localStorage item (direct): ${key}`, e);
    }
  }

  continueCallback = () => {
    this.setState({ isSpinnerDisplayed: "block" });
  };

  getMerchantDetails = (
    processInd,
    partnerId,
    amount,
    productCategoryNames,
    productCategoryNames1,
    productCategoryNames2,
    productCategoryNames3,
    transAmount1,
    transAmount2,
    transAmount3,
    syfToken,
    flowType,
    mppFromAnyWhereFlag,
    childSyfPartnerId,
    partnerCode,
    childSyfMerchantNumber,
    promoOverRideFlag,
    offerNumber1,
    offerNumber2,
    offerNumber3,
    tokenId,
    transactionToken,
    d2dFlow,
    merchantRefererUrl,
    partnerProfileCode,
    siteCode,
    clientTransId,
    clientName,
    mppApplicationLink,
    authorizationNumber,
    initialCallCompleted,
    widgetWebviewFlag,
    webviewAccessToken,
    syfMerchantNumber,
    channelId,
    orgFlow,
    acquisitionFlag,
    applyFromAnyWhereFlag,
    adobe_mcvid,
    payInFourProductConfigured,
    merchantDomainURL,
    productIds1,
    productIds2,
    productIds3
  ) => {
    this.setState({ isSpinnerDisplayed: "block" });
    const stripeFlow = new URLSearchParams(this.props.location.search).get("stripeFlow");

    (async () => {
      Services.fetchMerchantSpecificDetails(
        processInd,
        partnerId,
        amount,
        productCategoryNames,
        productCategoryNames1,
        productCategoryNames2,
        productCategoryNames3,
        transAmount1,
        transAmount2,
        transAmount3,
        syfToken,
        flowType,
        childSyfPartnerId,
        partnerCode,
        childSyfMerchantNumber,
        promoOverRideFlag,
        offerNumber1,
        offerNumber2,
        offerNumber3,
        tokenId,
        transactionToken,
        d2dFlow,
        merchantRefererUrl,
        partnerProfileCode,
        siteCode,
        clientTransId,
        clientName,
        mppApplicationLink,
        authorizationNumber,
        initialCallCompleted,
        widgetWebviewFlag,
        webviewAccessToken,
        syfMerchantNumber,
        channelId,
        getUpdatedFlow(orgFlow, "MPP"),
        mppFromAnyWhereFlag,
        acquisitionFlag,
        applyFromAnyWhereFlag,
        payInFourProductConfigured,
        merchantDomainURL,
        productIds1,
        productIds2,
        productIds3
      )
        .then((response) => {
          var count;
          mppFromAnyWhereFlag =
            response?.mppFromAnyWhereFlag ||
            response?.additionalInfo?.mppFromAnyWhereFlag ||
            mppFromAnyWhereFlag ||
            this.state.mppFromAnyWhereFlag ||
            "";

          if (mppFromAnyWhereFlag !== this.state.mppFromAnyWhereFlag) {
            this.setState({ mppFromAnyWhereFlag });
          }

          if(applyFromAnyWhereFlag){
             const responseAcquisitionFlag = response?.acquisitionFlag || this.state.acquisitionFlag || "";
             if(responseAcquisitionFlag === "A") {
               this.setState({ acquisitionFlag: responseAcquisitionFlag, mid: response?.mid || "", pcgc: response?.pcgc });
             }
             this.setState({ orgFlow: response?.orgFlow || this.state.orgFlow || "" });
          }

          this.setState({
            isPrequalified: true,
            isAmountEntryReadonly: false,
            isMerchantApiFailed: false,
            isSpinnerDisplayed: "none",
          });
          const {
            productStateInfo,
            ProductDetails,
            offersDetails,
            brandingInfo,
            isPayInFourAvailable,
            mppConfig: {
              showMppAmountInputBox,
              min,
              max,
              footerLinkColor,
              showToolTip,
              subtitlempp,
              pencilimg,
              plusCircleimg,
              addCartimg,
              quardCircleimg,
              pie1img,
              pie2img,
              pie3img,
              pie4img,
              triangleExclaminationimg,
              learchHowIconDownimg,
              learchHowIconUpimg,
              empqFlag,
              featureOfferFootermpp,
              subtitleNoteSoftapplympp,
              partnerProfileCode,
              initialCallCompleted,
              shoppingCartimg,
              applyDisableButtonText,
              cartInfoMsg,
              orgPlatForm,
              clientName,
              quickScreenApproved,
            },
            mppConfig,
            brandingInfo: {
              merchant_details: { isCloseEventCallBack, softapplyEnabled, applyDisabled, merchantWebsiteURL, merchantName,acquisitionFlag},
            },
            additionalInfo,
            dataShareToken,
            merchantNumber,
            storeNumber,
            clientId,
            quickScreenUserActivity,
            payInFourProductConfigured,
            applyUrl
          } = response;
          window.parent.postMessage({
            type: "SET_CLOSE_ARIA",
            merchantName: merchantName
          }, "*");
          window.parent.postMessage({ _isCloseEventCallBack: isCloseEventCallBack }, "*");
          let industryName =  this.state.industryName || response?.industryName || additionalInfo?.industryName || "";
          flowType = flowType || additionalInfo?.flowType || "";

          if(d2dFlow==="Y"){  
            if(!amount && !this.state.totalAmount){
              amount=additionalInfo.amount
            }
          }
          if (isPayInFourAvailable || (empqFlag && empqFlag == 'Y')) {
            window.parent.postMessage("redirectedToBnpl", "*");
          }
          if (quickScreenApproved && Object.keys(quickScreenUserActivity).length) {
            clientId && (quickScreenUserActivity['clientCode'] = clientId);
            window.parent.postMessage({ _qsEventType: "DISPLAY_OFFER" }, "*");
            this.setState({quickScreenUserActivity});
          }
          this.setState({ isSpinnerDisplayed: "none" });
          if(additionalInfo && (additionalInfo["flowType"] || additionalInfo["d2dSourceChannel"] === "CLOVER_PAY")){
            console.log("addtionalInfo block.....");
            this.setState({orgFlow: getOrgFlow(additionalInfo["flowType"] || flowType, d2dFlow, this.state.mppFromAnyWhereFlag, this.state.isCheckoutLearnClicked, this.state.fromEmail, this.state.sc, this.state.authorizationNumber,this.state.isQuickScreenDeclined,this.state.amount,this.state.applyFromAnyWhereFlag, additionalInfo["d2dSourceChannel"], additionalInfo["stripeFlow"] || stripeFlow)})
          }
          
          if(applyFromAnyWhereFlag){
            this.redirectToApplyFromAnyWhere();
            return;
          }
          
          if (productStateInfo) {
            const isPrequalApproved = productStateInfo.productStatus === "PREQUAL APPROVED";
            const isEmptyDataShareToken = dataShareToken === null || dataShareToken === "";
            const isPrequalPending = productStateInfo.productStatus === "PREQUAL_PENDING";
            const isApplyPending = productStateInfo.productStatus === "APPLY_PENDING";
            if (isPrequalApproved && isEmptyDataShareToken) {
              this.redirectToApply(empqFlag);
            } else if (isPrequalPending || isApplyPending) {
              var applyPrequalPendingStatus = "Pending";
              this.setState({
                applyPrequalPendingStatus: applyPrequalPendingStatus,
              });
            }
          }
          if (dataShareToken && dataShareToken != null) {
            window.parent.postMessage("redirectedToBnpl", "*");
            this.setState({
              isDataShareTokenAvailable: true
            })
            this.redirectToPayLater(dataShareToken);
          }
          if (offersDetails) {
            count = Object.keys(offersDetails.offerInfo).length;
            const noOfRevolvingPreferred = offersDetails.offerInfo
              .filter(offer =>
                ["WPDI", "EPNI", "FPRR", "EPNU", "EPNIIO", "PPPP", "EPNIIOPF", "EPNIPF"].includes(offer.offerType) &&
                offer.preferredOffer === "YES"
              ).length;
            const offersData =
              response.offersDetails.offerInfo[0].offerTitle ==
                "STANDARD PURCHASE"
                ? response.offersDetails.offerInfo[0]
                : response.offersDetails;

            this.setState({
              offersData,
              offersDetails,
              totalAmount: offersDetails.totalOfferAmount,
              offerDisclaimerLanguage: offersDetails.offerDisclaimer,
              offers: offersDetails.offerInfo,
              offerDisclaimer: offersDetails.offerDisclaimer,
              offerStaticLanguage: offersDetails.offerStaticLanguage,
              offerRangeLanguage: offersDetails.offerRangeLanguage,
              tooltipDisclosure: offersDetails.tooltipDisclosure,
              cardName: offersDetails.cardName,
              cardTitle: offersDetails.cardTitle,
              merchantProductGroups:
                offersDetails.productInfo.merchantPrdGrpInfos,
              empqPaylaterMonthlyFlag: offersDetails.empqPaylaterMonthlyFlag,
              noOfRevolvingPreferred
            });
            if (this.state.empqPaylaterMonthlyFlag === "Y") {
              window.parent.postMessage("redirectedToBnpl", "*");
            }
            if (
              offersDetails.productInfo.merchantPrdGrpInfos &&
              offersDetails.productInfo.merchantPrdGrpInfos.length > 0
            ) {
              this.setState({
                merchantNumber:
                  offersDetails.productInfo.merchantPrdGrpInfos[0]
                    .merchantNumber,
              });
            }
          }
          if (ProductDetails) {
            this.setState({ totalAmount: "" });
          } else if (
            !offersDetails &&
            (parseFloat(amount) === 0 || amount === "")
          ) {
            this.setState({ isMerchantApiFailed: true, totalAmount: "" });
          }
          else if (!offersDetails && amount && parseFloat(amount) > 0) {
             this.offerDetailsFailed(amount, widgetWebviewFlag,flowType);
          }
          if (this.state.mppFromEmail) {
            this.setState({ merchantWebsiteURL: brandingInfo.merchant_details.merchantWebsiteURL, })
          }
          
          if(mppConfig?.['mvcRetryEnabledanalytics'] == 'Y'){
            if(!this.state.adobe_mcvid) this.getMcvidFromLocal(mppConfig?.['mvcRetryCounteranalytics'], mppConfig?.['mvcRetryIntervalanalytics']); 
          }

          // Set data that are available on first call only(it need to run before initialCallCompleted is set to true in state)
          if(this.state.initialCallCompleted !== "true") {
            this.setState({ industryName });
          }
          
          this.setState({
            ProductDetails,
            isPrequalified:
              productStateInfo?.productStatus === "PREQUAL APPROVED"
                ? true
                : false,
            mppPrimaryColors:
              brandingInfo.product_details.mpp.product_specific_branding
                .mppPrimaryColors,
            merchantName: brandingInfo.merchant_details.merchantName,
            showMsfFlag: brandingInfo.product_details.mpp.showMSFOnMpp,
            brandings: brandingInfo.product_details.mpp.product_specific_branding,
            showMppAmountInputBox,
            subtitlempp,
            min,
            max,
            pencilimg,
            plusCircleimg,
            addCartimg,
            quardCircleimg,
            pie1img,
            pie2img,
            pie3img,
            pie4img,
            triangleExclaminationimg,
            learchHowIconDownimg,
            learchHowIconUpimg,
            empqFlag,
            footerLinkColor: brandingInfo.product_details.mpp
              .product_specific_branding.footerLinkColor
              ? brandingInfo.product_details.mpp.product_specific_branding
                .footerLinkColor
              : footerLinkColor,
            isToolTip: brandingInfo.product_details.mpp.product_specific_branding
              .showToolTip
              ? brandingInfo.product_details.mpp.product_specific_branding
                .showToolTip
              : showToolTip,
            toolTipContent:
              brandingInfo.product_details.mpp.product_specific_branding
                .toolTipContent,
            additionalInfo,
            flowType: flowType || additionalInfo?.flowType,
            partnerId: partnerId || additionalInfo?.partnerId,
            softapplyEnabled,
            featureOfferFootermpp,
            subtitleNoteSoftapplympp,
            partnerProfileCode,
            initialCallCompleted,
            applyDisabled,
            shoppingCartimg,
            applyDisableButtonText,
            cartInfoMsg,
            merchantWebsiteURL,
            orgPlatForm,
            clientName,
            mppConfig,
            qsDeclineScreenPayload : { 
              authorizationNumber,
              merchantNumber,
              storeNumber,
              clientId,
              syfToken
            },
            quickScreenUserActivity,
            clientCode : clientId,
            payInFourProductConfigured,
          });
           
          const setpayin4Offer = this.state.offers.filter((item) => {
            return item.offerType === "SetPAYIn4";
          });
          this.setState({
            isSetPayIn4Alone: this.state.offers.length === 1 && this.state.offers[0].offerType === "SetPAYIn4" ? true : false
          })
          this.setState({ setPayIn4Info: setpayin4Offer[0]?.setPayIn4Info });

          !siteCode && this.setState(prev => ({ queryValues:{ ...prev.queryValues, siteCode: response.siteCode }}))

          var deviceType = getDeviceType();

          var toolTipEnabled = this.state.isToolTip === "Y" && this.state.toolTipContent;
          var tagsEnabled = productCategoryNames ? true : false;
          var messageType = "";
          if (toolTipEnabled) {
            messageType += "ToolTipEnabled";
          }
          if (tagsEnabled) {
            if (toolTipEnabled) {
              messageType += "/"
            }
            messageType += "TagsEnabled"
          }

          // Compute ExtendedFeatures: count offers with a non-null / non-blank loyaltyPromoDisclosure.
          // Default to "" when no offers have a valid loyalty disclosure value.
          const loyaltyPromoCount = offersDetails?.offerInfo
            ? offersDetails.offerInfo.filter(
                (offer) =>
                  offer.loyaltyPromoDisclosure != null &&
                  String(offer.loyaltyPromoDisclosure).trim() !== ""
              ).length
            : 0;
          const extendedFeatures = loyaltyPromoCount > 0 ? `loyalty_${loyaltyPromoCount}` : "";

          if(this.state.isMsfApplyBuyFlow != "true"){
            window._syf_._mppOffer_._SFDDL.pageInfo = {
              Country_Language: "US|ENG",
              SiteIdentifier: "digitalpos",
              Device: deviceType,
              PNL: "PS",
              CustomerType: "consumer",
              ClientName: this.state.merchantName,
              MerchantID: this.state.merchantNumber,
              PageKind: "merchant",
              PageFunction: this.state.mppFromEmail ? "EmailableMPP" : this.state.sc ? "QRMPP" : this.state.mppFromAnyWhereFlag === 'Y' ? "MPPDirect" : "offers_mpp",
              PageSubFunction: quickScreenApproved ? "pre_approved_qs" : "",
              PageName: "offer_details_page",
              Placements: mppFromAnyWhereFlag === "Y" ? "" : getPlacements(flowType || additionalInfo["flowType"], "", this.state.isCheckoutLearnClicked, d2dFlow),
              OfferCount: count,
              TargetName: "",
              TokenId: syfToken,
              Message: "MPP Page Load",
              OfferType: "",
              SyfPartnerID: partnerId  || additionalInfo?.partnerId,
              orgChannel: "POS",
              orgFlow: stripeFlow === "Y" && this.state.orgFlow === "Checkout-MPP" ? "Checkout-Stripe-MPP" : this.state.orgFlow === "Checkout-Stripe-MPP-dBuy" ? "Checkout-Stripe-MPP-dBuy" : getUpdatedFlow(this.state.orgFlow, "MPP"),
              orgPlatForm,
              MessageType: messageType,
              GenericTag: messageType != "" ? "Yes" : "No",
              adobe_mcvid: adobe_mcvid || "",
              siteCode : siteCode ? siteCode : response?.siteCode,
              D2DToken : additionalInfo?.d2dToken || "",
              D2DsourceChannel: additionalInfo?.d2dSourceChannel || "",
              Market: industryName || "",
              ExtendedFeatures: extendedFeatures
            };
            window._syf_._mppOffer_._SFDDL.formAction = {
              appType: "offers_mpp",
              product: "MPP",
              action: "offer_details_page",
            };

            if (mppFromAnyWhereFlag === "Y") {
              analyticsChangesForMPPAnywhere(
                this.state.merchantName,
                this.state.merchantNumber,
                partnerId,
                flowType,
                syfToken,
                count,
                deviceType,
                messageType,
                orgPlatForm,
                this.state.orgFlow,
                siteCode ? siteCode : response?.siteCode,
                industryName || "",
                extendedFeatures,
                mppFromAnyWhereFlag,
                additionalInfo?.d2dToken,
                additionalInfo?.d2dSourceChannel
              );
            } else {
              var event = document.createEvent("Event");
              event = new CustomEvent("syfPageView");
              event.initEvent("syfPageView");
              (function tryDispatch() {
                if(window.utag){
                console.log("utag.js loaded");
                dispatchEvent(event);
                } else {
                  console.log("waiting for utag.js");
                  setTimeout(tryDispatch, 200);
                }
              })();
            }
          }
          
        })
        .catch((err) => {
          const responseSuccessCode = 200;
          console.error("error occurred while processing/fetching getMerchantDetails :", err);
          if (err && err.response && err.response.status !== responseSuccessCode) {
            widgetWebviewFlag = "Y";
          }
          this.offerDetailsFailed(amount, widgetWebviewFlag, flowType);
        });

    })();
  };
  offerDetailsFailed(amount, widgetWebviewFlag, flowType) {
    if (widgetWebviewFlag === "Y") {
      this.setState({ isWebviewTokenValidationFailed: true });
    }
    this.setState({
      isMerchantApiFailed: true,
      isPrequalified: false,
      flowType: flowType || "",
      isSpinnerDisplayed: "none",
      totalAmount: amount?.replace(/^0+/, ""),
    });
  }

  getMcvidFromLocal = (retryLimit, retryTimeout) => {
    let attempts = 0;
    const interValid = setInterval(() => {
      let tempMcivd = this.safeGetItemDirect('adobe_mcvid');
      attempts++;
      if (tempMcivd) {
        this.setState({ ...this.state, adobe_mcvid: tempMcivd });
        window._syf_._mppOffer_._SFDDL.pageInfo['adobe_mcvid'] = tempMcivd
        clearInterval(interValid);
      } else {
        if (attempts >= retryLimit) {
          clearInterval(interValid);
        }
      }
    }, retryTimeout);
  }

  redirectToMpq = () => {

    this.setState({ isSpinnerDisplayed: "block" });
    const mppUrl = new URLSearchParams(this.props.location.search);
    const query = Object.fromEntries(mppUrl);
    const partnerId = query["partnerId"];
    const syfToken = query["syfToken"];
    let empqFlag = query["empq"];
    let dataShareToken = query["dataShareToken"];
    if(dataShareToken){
      this.redirectToPayLater(dataShareToken);
    } else {

      if (window && window.parent) {
        var parent = window.parent;
        parent.postMessage("changeCloseBtnPosition", "*");
      }
      var url = configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost + "?preQual=Y";

      if (partnerId) url = url + "&syfPartnerId=" + partnerId;
      if (syfToken) url = url + "&syfToken=" + syfToken;

      var mainUrl = "";
      try {
        var visitor = window.Visitor.getInstance(
          "22602B6956FAB4777F000101@AdobeOrg"
        );
        mainUrl =
          visitor.appendVisitorIDsTo(url) != undefined
            ? visitor.appendVisitorIDsTo(url)
            : url;
      } catch (error) {
        mainUrl = url;
      }
      if (empqFlag && empqFlag == 'Y') {
        mainUrl = mainUrl + "&empq=Y&modalapply=true"
      }
      window.location.href = mainUrl;

    }

  };
  redirectToApply = (empqFlag) => {
    this.setState({ isSpinnerDisplayed: "block" });
    const query = new URLSearchParams(this.props.location.search);
    const mid = query.get("mid");
    const amount = query.get("amount");
    const pcgc = query.get("pcgc");
    const syfToken = query.get("syfToken");
    if (window && window.parent) {
      var parent = window.parent;
      parent.postMessage("changeCloseBtnPosition", "*");
    }

    var url =
      configuration[window._syfMpp_.SYF_MPP_ENV].applyHost +
      "?mid=" +
      mid +
      "&pcgc=" +
      pcgc +
      "&syfToken=" +
      this.state.syfToken;
    var mainUrl = "";
    try {
      var visitor = window.Visitor.getInstance(
        "22602B6956FAB4777F000101@AdobeOrg"
      );
      mainUrl =
        visitor.appendVisitorIDsTo(url) != undefined
          ? visitor.appendVisitorIDsTo(url)
          : url;
    } catch (error) {
      mainUrl = url;
    }
    if (empqFlag && empqFlag == 'Y') {
      mainUrl = mainUrl + "&empq=Y&modalapply=true"
    }
    window.location.href = mainUrl;
  };


  redirectToApplyFromAnyWhere = () => {
    this.setState({ isSpinnerDisplayed: "block" });
    if (window && window.parent) {
      var parent = window.parent;
      parent.postMessage("changeCloseBtnPosition", "*");
    }
    const { acquisitionFlag, mid, pcgc,partnerId,syfToken } = this.state;
    
    let url="" ;
    if(acquisitionFlag && acquisitionFlag==='A'){

      url =
      configuration[window._syfMpp_.SYF_MPP_ENV].applyHost +
      "?mid=" +
      mid +
      "&pcgc=" +
      pcgc +
      "&syfToken=" +
      this.state.syfToken+
      "&channelCode=DY";

    }else {

      url =
      configuration[window._syfMpp_.SYF_MPP_ENV].applyHost +
      "?syfToken=" +
      this.state.syfToken+
      "&syfPartnerId=" + partnerId +
      "&empq=Y&modalapply=true&preQual=Y";

    }
    console.log("redirectToApply url", url);
    var mainUrl = "";
    try {
      var visitor = window.Visitor.getInstance(
        "22602B6956FAB4777F000101@AdobeOrg"
      );
      mainUrl =
        visitor.appendVisitorIDsTo(url) != undefined
          ? visitor.appendVisitorIDsTo(url)
          : url;
    } catch (error) {
      mainUrl = url;
    }
    window.location.href = mainUrl;
  };

  redirectToPayLater = (dataShareToken) => {
    this.setState({ isSpinnerDisplayed: "block" });
    if (window && window.parent) {
      var parent = window.parent;
      parent.postMessage("changeCloseBtnPosition", "*");
    }
    var url =
      configuration[window._syfMpp_.SYF_MPP_ENV].payLaterUrl +
      "/" + dataShareToken
    var mainUrl = "";
    try {
      var visitor = window.Visitor.getInstance(
        "22602B6956FAB4777F000101@AdobeOrg"
      );
      mainUrl =
        visitor.appendVisitorIDsTo(url) != undefined
          ? visitor.appendVisitorIDsTo(url)
          : url;
    } catch (error) {
      mainUrl = url;
    }
    window.location.href = mainUrl;
  };

  openApplyOrPrequal = async () => {
    //show spinner
    const {
      setPayIn4Info,
      queryValues,
      queryValues: {
        merchantDomainURL,
        childSyfPartnerId,
        partnerCode,
        d2dFlow,
        childSyfMerchantNumber,
        storeMid,
        merchantRefererUrl,
        partnerProfileCode,
        siteCode,
        clientTransId,
        mppFromAnyWhereFlag,
        isEcartPromoOverRideAvailable,
        tokenId,
        operatorId,
        dataShareToken,
        acquisitionFlag,
		    applyFromAnyWhereFlag,
      },
      empqFlag,
      totalAmount,
      additionalInfo,
      syfMerchantNumber,
      channelId,
      originUrl,
      softapplyEnabled,
      orgFlow,
      adobe_mcvid,
      clientCode
    } = this.state;

    let formPostData = {};
    let applicationType = "";
    const requestParams = { ...queryValues, ...additionalInfo }

    const fetchMultiBuckets = { ...queryValues }

    if(window._qsEventType && window._qsEventType === "VIEW_OFFER"){
      applicationType = "QS"
    }
    else if(window._qsEventType === "NOT_ME_APPLY"){
      applicationType = "EMPQ"
    }

    if(window._qsEventType === "VIEW_OFFER" || 
      window._qsEventType === "NOT_ME_APPLY"
    ){
      let qsdata = this.state.quickScreenUserActivity;
      formPostData["custFirstName"] = qsdata["firstName"];
      formPostData["custLastName"] = qsdata["lastName"];
      formPostData["custAddress1"] = qsdata["addressLine1"];
      formPostData["custAddress2"] = qsdata["addressLine2"];
      formPostData["custCity"] = qsdata["city"];
      formPostData["custState"] = qsdata["state"];
      formPostData["custZipCode"] = qsdata["zipCode"];
      formPostData["authorizationNumber"] = qsdata["finderFileNumber"];
      formPostData["productcodegroupcode"] = qsdata["productcodegroupcode"];
      formPostData["promoCode"] = this.state.offersDetails.quickScreenInfo.promoCode
      formPostData["merchantId"] = qsdata["merchantId"];
      if (channelId) formPostData["channelId"] = channelId;
      if(qsdata["emailAddress"]){
        formPostData["emailAddr"] = qsdata["emailAddress"];
      }
    }
    else{
      Object.keys(requestParams).forEach((key) => {
        if (
          [
            "tokenId",
            "partnerId",
            "processInd",
            "childSyfMerchantNumber",
            "adobe_mc",
            "syfToken",
            "syfPartnerId",
            "encryptKey",
            "flowType",
            "modalType",
            "childPcgc",
            "childTransType",
            "pcgc",
            "partnerCode",
            "clientToken",
            "postbackid",
            "clientTransId",
            "cardNumber",
            "custFirstName",
            "custLastName",
            "expMonth",
            "expYear",
            "custZipCode",
            "custAddress1",
            "custAddress2",
            "phoneNumb",
            "appartment",
            "emailAddr",
            "custCity",
            "upeProgramName",
            "custState",
            "transPromo1",
            "iniPurAmt",
            "mid",
            "productCategoryNames1",
            "productCategoryNames2",
            "productCategoryNames3",
            "productCategoryNames",
            "promotionalTags2",
            "promotionalTags3",
            "transAmount1",
            "transAmount2",
            "transAmount3",
            "initialAmount",
            "envUrl",
            "passedJson",
            "childSyfPartnerId",
            "partnerCode",
            "d2dFlow",
            "childSyfMerchantNumber",
            "storeMid",
            "promoOverRideFlag",
            "offerNumber1",
            "offerNumber2",
            "offerNumber3",
            "merchantRefererUrl",
            "partnerProfileCode",
            "siteCode",
            "isEcartPromoOverRideAvailable",
            "clientTransId",
            "editAmountOnConsumerOffer",
            "transactionType",
            "DBuy"
          ].includes(key)
        ) {
          formPostData[key] = requestParams[key];
        }
        // if (key === "passedJson") {
        //   formPostData[key] = JSON.parse(queryValues[key]);
        // }
      });
    }

   if(formPostData.d2dFlow !== undefined  && formPostData.d2dFlow === 'Y'){
     if(!(fetchMultiBuckets['transAmount1'] === undefined || fetchMultiBuckets['transAmount1'] === null)){
        formPostData['transAmount1'] = fetchMultiBuckets['transAmount1'];
      }
     if(!(fetchMultiBuckets['transAmount2'] === undefined || fetchMultiBuckets['transAmount2'] === null)){
        formPostData['transAmount2'] = fetchMultiBuckets['transAmount2'];
      }
     if(!(fetchMultiBuckets['transAmount3'] === undefined || fetchMultiBuckets['transAmount3'] === null)){
        formPostData['transAmount3'] = fetchMultiBuckets['transAmount3'];
      }
    }
    if (formPostData.passedJson) {
      delete formPostData.flowType;
    }

    this.setState({ isSpinnerDisplayed: "block" });
    const query = new URLSearchParams(this.props.location.search);
    const partnerId = query.get("partnerId") || additionalInfo?.partnerId;
    const pcgc = query.get("pcgc");
    const stripeFlow = query.get("stripeFlow");
    var syfToken = query.get("syfToken");
    var flowType = query.get("flowType") || additionalInfo?.flowType;
    const clientName = this.state.clientName || this.state.merchantName;
    let productCategoryNames1 = query.get("productCategoryNames1");
    let productCategoryNames = query.get("productCategoryNames");
    let productCategoryNames2 = query.get("productCategoryNames2");
    let productCategoryNames3 = query.get("productCategoryNames3");
    const passedJson = query.get("passedJson");
    let tags = query.get("tag");

    if (tags) {
      productCategoryNames = tags
    }

    if (passedJson) {
      const response = JSON.parse(passedJson);

      if (!productCategoryNames) {
        if (response && response.productCategoryNames)
          productCategoryNames = response.productCategoryNames;
        if (response && response.promotionalTags)
          productCategoryNames = response.promotionalTags;
      }

      if (!productCategoryNames1) {
        if (response && response.productCategoryNames1)
          productCategoryNames1 = response.productCategoryNames1;
        if (response && response.promotionalTags1)
          productCategoryNames1 = response.promotionalTags1;
      }
      if (!productCategoryNames2) {
        if (response && response.productCategoryNames2)
          productCategoryNames2 = response.productCategoryNames2;
        if (response && response.promotionalTags2)
          productCategoryNames2 = response.promotionalTags2;
      }

      if (!productCategoryNames3) {
        if (response && response.productCategoryNames3)
          productCategoryNames3 = response.productCategoryNames3;
        if (response && response.promotionalTags3)
          productCategoryNames3 = response.promotionalTags3;
      }
    }

    formPostData = JSON.stringify(formPostData);

    if (window && window.parent) {
      var parent = window.parent;
      parent.postMessage("changeCloseBtnPosition", "*");
    }
    const fromEmail = query.get("fromEmail");
    const sc = query.get("sc");
    const fromWebview = query.get("fromWebview");
    let merchantWebsiteURL = this.state.merchantWebsiteURL;
    if (fromEmail === "Y" || fromWebview === "Y" || sc === "QR") {
      syfToken = this.state.syfToken;
      flowType = this.state.flowType;
    }
    const empqPaylaterMonthlyFlag = this.state.empqPaylaterMonthlyFlag;
    const actionType = "DAPPLY";
    let qsDataToCheckoutApi = {}
    if(this.state.quickScreenUserActivity){
      qsDataToCheckoutApi = {
        authorizationNumber : this.state.quickScreenUserActivity["finderFileNumber"],
        applicationType
      }
    }

    await Services.sendDataToCheckoutApi(
      partnerId,
      pcgc,
      totalAmount,
      syfToken,
      flowType,
      clientName,
      productCategoryNames,
      setPayIn4Info,
      formPostData,
      merchantDomainURL ? merchantDomainURL : originUrl,
      childSyfPartnerId,
      partnerCode,
      d2dFlow,
      childSyfMerchantNumber,
      empqFlag,
      fromEmail,
      sc,
      merchantWebsiteURL,
      empqPaylaterMonthlyFlag,
      merchantRefererUrl,
      partnerProfileCode,
      softapplyEnabled,
      siteCode,
      clientTransId,
      mppFromAnyWhereFlag,
      actionType,
      tokenId,
      operatorId,
      dataShareToken,
      qsDataToCheckoutApi,
      syfMerchantNumber, 
      channelId,
      getUpdatedFlow(this.state.orgFlow, window._qsEventType === "VIEW_OFFER" ? "QSApply" : "MPQ", stripeFlow),
      adobe_mcvid,
      this.state.industryName,
      clientCode,
      acquisitionFlag,
      applyFromAnyWhereFlag,
      additionalInfo?.d2dSourceChannel,
      additionalInfo?.uniqueId
    )
      .then((response) => {
        var url = "";
        if (this.state.brandings.preQual === "true" && empqFlag !== 'Y') {
          // analyticsChangesForPrequalifyNow(
          //   this.state.merchantName,
          //   this.state.merchantNumber,
          //   this.state.syfToken,
          //   this.state.partnerId,
          //   this.state.flowType,
          //   this.state.orgPlatForm
          // );
          const pre_Qual = "Y";
          //url=configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost+"?syfPartnerId="+partnerId+"&preQual="+pre_Qual+"&syfToken="+response.transactionId;
          url = generateGALinkerId(
            configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost +
            "?syfPartnerId=" +
            partnerId +
            "&preQual=" +
            pre_Qual +
            "&syfToken=" +
            response.transactionId +
            "&cid=" +
            this.state.cid
          );
        } else {
          // analyticsChangesForApply(
          //   this.state.merchantName,
          //   this.state.merchantNumber,
          //   this.state.syfToken,
          //   this.state.partnerId,
          //   this.state.flowType,
          //   this.state.orgPlatForm
          // );
          url =
            configuration[window._syfMpp_.SYF_MPP_ENV].applyHost +
            "?syfPartnerId=" +
            partnerId +
            "&pcgc=" +
            pcgc +
            "&syfToken=" +
            response.transactionId +
            "&cid=" +
            this.state.cid;
        }
        var mainUrl = "";
        try {
          var visitor = window.Visitor.getInstance(
            "22602B6956FAB4777F000101@AdobeOrg"
          );
          var temp = visitor.appendVisitorIDsTo(url);
          if (temp == undefined) {
            mainUrl = url;
          } else {
            mainUrl = temp;
          }
        } catch (error) {
          mainUrl = url;
        }
        if (empqFlag && empqFlag == 'Y') {
          mainUrl = mainUrl + "&empq=Y&modalapply=true"
        }
        window.location.href = mainUrl;
      })
      .catch((err) => {
        this.setState({ isCheckoutDataApiFailed: true });
      });

    var url = "";
    if (this.state.brandings.preQual === "true") {
      // analyticsChangesForPrequalifyNow(
      //   this.state.merchantName,
      //   this.state.merchantNumber,
      //   this.state.syfToken,
      //   this.state.partnerId,
      //   this.state.flowType,
      //   this.state.orgPlatForm
      // );
      const pre_Qual = "Y";
      //url=configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost+"?syfPartnerId="+partnerId+"&preQual="+pre_Qual+"&syfToken="+response.transactionId;
      url = generateGALinkerId(
        configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost +
        "?syfPartnerId=" +
        partnerId +
        "&preQual=" +
        pre_Qual +
        "&syfToken=" +
        this.state.syfToken +
        "&cid=" +
        this.state.cid
      );
    } else {
      // analyticsChangesForApply(
      //   this.state.merchantName,
      //   this.state.merchantNumber,
      //   this.state.syfToken,
      //   this.state.partnerId,
      //   this.state.flowType,
      //   this.state.orgPlatForm
      // );
      url =
        configuration[window._syfMpp_.SYF_MPP_ENV].applyHost +
        "?syfPartnerId=" +
        partnerId +
        "&pcgc=" +
        pcgc +
        "&syfToken=" +
        this.state.syfToken +
        "&cid=" +
        this.state.cid;
    }
    var mainUrl = "";
    try {
      var visitor = window.Visitor.getInstance(
        "22602B6956FAB4777F000101@AdobeOrg"
      );
      var temp = visitor.appendVisitorIDsTo(url);
      if (temp == undefined) {
        mainUrl = url;
      } else {
        mainUrl = temp;
      }
    } catch (error) {
      mainUrl = url;
    }

    window.location.href = mainUrl;

    var url = "";
    if (this.state.brandings.preQual === "true") {
      // analyticsChangesForPrequalifyNow(
      //   this.state.merchantName,
      //   this.state.merchantNumber,
      //   this.state.syfToken,
      //   this.state.partnerId,
      //   this.state.flowType,
      //   this.state.orgPlatForm
      // );
      const pre_Qual = "Y";
      //url=configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost+"?syfPartnerId="+partnerId+"&preQual="+pre_Qual+"&syfToken="+response.transactionId;
      if (qsDataToCheckoutApi.authorizationNumber) {
        url = generateGALinkerId(configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost + "?syfToken=" + this.state.syfToken + "&cid=" + this.state.cid)
      }
      else {
        url = generateGALinkerId(
        configuration[window._syfMpp_.SYF_MPP_ENV].preqApplyHost +
        "?syfPartnerId=" +
        partnerId +
        "&preQual=" +
        pre_Qual +
        "&syfToken=" +
        this.state.syfToken +
        "&cid=" +
        this.state.cid
      );
      }
      
    } else {
      // analyticsChangesForApply(
      //   this.state.merchantName,
      //   this.state.merchantNumber,
      //   this.state.syfToken,
      //   this.state.partnerId,
      //   this.state.flowType,
      //   this.state.orgPlatForm
      // );
      url =
        configuration[window._syfMpp_.SYF_MPP_ENV].applyHost +
        "?syfPartnerId=" +
        partnerId +
        "&pcgc=" +
        pcgc +
        "&syfToken=" +
        this.state.syfToken +
        "&cid=" +
        this.state.cid;
    }
    var mainUrl = "";
    try {
      var visitor = window.Visitor.getInstance(
        "22602B6956FAB4777F000101@AdobeOrg"
      );
      var temp = visitor.appendVisitorIDsTo(url);
      if (temp == undefined) {
        mainUrl = url;
      } else {
        mainUrl = temp;
      }
    } catch (error) {
      mainUrl = url;
    }
    if (empqFlag && empqFlag == 'Y') {
       if (window._qsEventType === "VIEW_OFFER") {
        mainUrl = mainUrl + "&modalapply=true"
      }
      else {
        mainUrl = mainUrl + "&empq=Y&modalapply=true"
      }
    }
    window.location.href = mainUrl;
  };

  openSetPayIn4 = async () => {
    //show spinner
    if (this.state.orgFlow === "Checkout-Stripe-MPP-dBuy") {
      window._syf_._mppOffer_._SFDDL.pageInfo = {
        ...window._syf_._mppOffer_._SFDDL.pageInfo,
        orgFlow: "Stripe-Apply-Buy"
      };
    }
    const {
      setPayIn4Info,
      queryValues,
      queryValues: {
        merchantDomainURL,
        childSyfPartnerId,
        partnerCode,
        flowType,
        d2dFlow,
        childSyfMerchantNumber,
        storeMid,
        merchantRefererUrl,
        partnerProfileCode,
        siteCode,
        clientTransId,
        mppFromAnyWhereFlag,
        isEcartPromoOverRideAvailable,
        tokenId,
        operatorId,
        dataShareToken,
      },
      empqFlag,
      totalAmount,
      additionalInfo,
      originUrl,
      softapplyEnabled,
      syfMerchantNumber,
      channelId,
      orgFlow,
      adobe_mcvid
    } = this.state;

    let formPostData = {};
    const requestParams = { ...queryValues, ...additionalInfo }
    const actionType = "PAYIN4";

    const clientName = this.state.clientName || this.state.merchantName;

    Object.keys(requestParams).forEach((key) => {
      if (
        [
          "tokenId",
          "partnerId",
          "processInd",
          "childSyfMerchantNumber",
          "adobe_mc",
          "syfToken",
          "syfPartnerId",
          "encryptKey",
          "flowType",
          "modalType",
          "childPcgc",
          "childTransType",
          "pcgc",
          "partnerCode",
          "clientToken",
          "postbackid",
          "clientTransId",
          "cardNumber",
          "custFirstName",
          "custLastName",
          "expMonth",
          "expYear",
          "custZipCode",
          "custAddress1",
          "custAddress2",
          "phoneNumb",
          "appartment",
          "emailAddr",
          "custCity",
          "upeProgramName",
          "custState",
          "transPromo1",
          "iniPurAmt",
          "mid",
          "productCategoryNames1",
          "productCategoryNames2",
          "productCategoryNames3",
          "productCategoryNames",
          "promotionalTags2",
          "promotionalTags3",
          "transAmount1",
          "transAmount2",
          "transAmount3",
          "initialAmount",
          "envUrl",
          "passedJson",
          "childSyfPartnerId",
          "partnerCode",
          "d2dFlow",
          "childSyfMerchantNumber",
          "storeMid",
          "promoOverRideFlag",
          "offerNumber1",
          "offerNumber2",
          "offerNumber3",
          "isEcartPromoOverRideAvailable",
          "merchantID"
        ].includes(key)
      ) {
        formPostData[key] = requestParams[key];
      }
      // if (key === "passedJson") {
      //   formPostData[key] = JSON.parse(queryValues[key]);
      // }
    });

    if (formPostData.passedJson) {
      delete formPostData.flowType;
    }

    this.setState({ isSpinnerDisplayed: "block" });
    const query = new URLSearchParams(this.props.location.search);
    requestParams.flowType = query.get("flowType") || additionalInfo?.flowType;
    formPostData["flowType"]  = requestParams.flowType;
    

    formPostData = JSON.stringify(formPostData);
    this.setState({ formPostData: formPostData });

    try{

      const response = await Services.sendDataToCheckoutApi(
        requestParams.partnerId,
        requestParams.pcgc,
        requestParams.totalAmount,
        requestParams.syfToken,
        requestParams.flowType,
        clientName,
        requestParams.productCategoryNames,
        requestParams.setPayIn4Info,
        formPostData,
        formPostData.merchantDomainURL,
        requestParams.childSyfPartnerId,
        requestParams.partnerCode,
        requestParams.d2dFlow,
        requestParams.childSyfMerchantNumber,
        requestParams.empqFlag,
        requestParams.fromEmail,
        requestParams.sc,
        requestParams.merchantWebsiteURL,
        requestParams.empqPaylaterMonthlyFlag,
        merchantRefererUrl,
        partnerProfileCode,
        softapplyEnabled,
        siteCode,
        clientTransId,
        mppFromAnyWhereFlag,
        actionType,
        tokenId,
        operatorId,
        dataShareToken,"",
        syfMerchantNumber,
        channelId,
        getUpdatedFlow(this.state.orgFlow, "MPP"),
        adobe_mcvid,
        this.state.industryName
      )
      this.setState({ isCheckoutDataApiFailed: false });
      window.location.href = this.state.url || this.state.additionalInfo?.url;
    } catch(err){
      console.log("error occurred while calling checkout api :", err);
      this.setState({ isCheckoutDataApiFailed: true });
    }


  };

  openPayLater = async () => {
    //show spinner
    const {
      setPayIn4Info,
      queryValues,
      queryValues: {
        merchantDomainURL,
        childSyfPartnerId,
        partnerCode,
        d2dFlow,
        childSyfMerchantNumber,
        storeMid,
        isEcartPromoOverRideAvailable,
        tokenId
      },
      empqFlag,
      totalAmount,
    } = this.state;

    let formPostData = {};

    Object.keys(queryValues).forEach((key) => {
      if (
        [
          "tokenId",
          "partnerId",
          "processInd",
          "childSyfMerchantNumber",
          "adobe_mc",
          "syfToken",
          "syfPartnerId",
          "encryptKey",
          "flowType",
          "modalType",
          "childPcgc",
          "childTransType",
          "pcgc",
          "partnerCode",
          "clientToken",
          "postbackid",
          "clientTransId",
          "cardNumber",
          "custFirstName",
          "custLastName",
          "expMonth",
          "expYear",
          "custZipCode",
          "custAddress1",
          "phoneNumb",
          "appartment",
          "emailAddr",
          "custCity",
          "upeProgramName",
          "custState",
          "transPromo1",
          "iniPurAmt",
          "mid",
          "productCategoryNames1",
          "productCategoryNames2",
          "productCategoryNames3",
          "productCategoryNames",
          "promotionalTags2",
          "promotionalTags3",
          "transAmount1",
          "transAmount2",
          "transAmount3",
          "initialAmount",
          "envUrl",
          "passedJson",
          "childSyfPartnerId",
          "partnerCode",
          "d2dFlow",
          "childSyfMerchantNumber",
          "isEcartPromoOverRideAvailable",
          "storeMid"
        ].includes(key)
      ) {
        formPostData[key] = queryValues[key];
      }
      // if (key === "passedJson") {
      //   formPostData[key] = JSON.parse(queryValues[key]);
      // }
    });

    if (formPostData.passedJson) {
      delete formPostData.flowType;
    }

    this.setState({ isSpinnerDisplayed: "block" });
    const query = new URLSearchParams(this.props.location.search);
    const partnerId = query.get("partnerId");
    const amount = query.get("amount");
    const transAmount1 = query.get("transAmount1");
    const transAmount2 = query.get("transAmount2");
    const transAmount3 = query.get("transAmount3");
    const pcgc = query.get("pcgc");
    var syfToken = query.get("syfToken");
    var flowType = query.get("flowType");
    const clientName = this.state.clientName || this.state.merchantName;
    let productCategoryNames1 = query.get("productCategoryNames1");
    let productCategoryNames = query.get("productCategoryNames");
    let productCategoryNames2 = query.get("productCategoryNames2");
    let productCategoryNames3 = query.get("productCategoryNames3");
    const promoOverRideFlag = query.get("promoOverRideFlag");
    const passedJson = query.get("passedJson");
    let tags = query.get("tag");

    if (tags) {
      productCategoryNames = tags
    }

    if (passedJson) {
      const response = JSON.parse(passedJson);

      if (!productCategoryNames) {
        if (response && response.productCategoryNames)
          productCategoryNames = response.productCategoryNames;
        if (response && response.promotionalTags)
          productCategoryNames = response.promotionalTags;
      }

      if (!productCategoryNames1) {
        if (response && response.productCategoryNames1)
          productCategoryNames1 = response.productCategoryNames1;
        if (response && response.promotionalTags1)
          productCategoryNames1 = response.promotionalTags1;
      }
      if (!productCategoryNames2) {
        if (response && response.productCategoryNames2)
          productCategoryNames2 = response.productCategoryNames2;
        if (response && response.promotionalTags2)
          productCategoryNames2 = response.promotionalTags2;
      }

      if (!productCategoryNames3) {
        if (response && response.productCategoryNames3)
          productCategoryNames3 = response.productCategoryNames3;
        if (response && response.promotionalTags3)
          productCategoryNames3 = response.promotionalTags3;
      }
    }

    formPostData = JSON.stringify(formPostData);

    if (window && window.parent) {
      var parent = window.parent;
      parent.postMessage("changeCloseBtnPosition", "*");
    }
    const fromEmail = query.get("fromEmail");
    const sc = query.get("sc");
    const fromWebview = query.get("fromWebview");
    let merchantWebsiteURL = this.state.merchantWebsiteURL;
    if (fromEmail === "Y" || fromWebview === "Y" || sc === "QR") {
      syfToken = this.state.syfToken;
      flowType = this.state.flowType;
    }
    const empqPaylaterMonthlyFlag = this.state.empqPaylaterMonthlyFlag;


    await Services.sendDataToDataShareApi(
      partnerId,
      pcgc,
      totalAmount,
      syfToken,
      flowType,
      clientName,
      productCategoryNames,
      setPayIn4Info,
      formPostData,
      merchantDomainURL,
      childSyfPartnerId,
      partnerCode,
      d2dFlow,
      childSyfMerchantNumber,
      empqFlag,
      fromEmail,
      sc,
      merchantWebsiteURL,
      empqPaylaterMonthlyFlag,
      tokenId
    )
      .then((response) => {
        var url = url = generateGALinkerId(
          configuration[window._syfMpp_.SYF_MPP_ENV].payLaterLookUpUrl +
          "/" + response.token
        );
        var mainUrl = "";
        try {
          var visitor = window.Visitor.getInstance(
            "22602B6956FAB4777F000101@AdobeOrg"
          );
          var temp = visitor.appendVisitorIDsTo(url);
          if (temp == undefined) {
            mainUrl = url;
          } else {
            mainUrl = temp;
          }
        } catch (error) {
          mainUrl = url;
        }
        window.location.href = mainUrl;
      })
      .catch((err) => {
        this.setState({ isCheckoutDataApiFailed: true });
      });
  }

  debounceCallback = debounce(
    (price) => {
      const {
        partnerId,
        productCategoryNames,
        syfToken,
        flowType,
        mppFromAnyWhereFlag,
        promoOverRideFlag,
        offerNumber1,
        channelId,
        syfMerchantNumber,
        adobe_mcvid,
        orgFlow,
        acquisitionFlag,
        applyFromAnyWhereFlag,
        productIds1,
        productIds2,
        productIds3,
        queryValues: { childSyfPartnerId, partnerCode, childSyfMerchantNumber, d2dFlow, partnerProfileCode, merchantRefererUrl, processInd, siteCode, clientTransId, clientName, mppApplicationLink, authorizationNumber },
      } = this.state;

      this.getMerchantDetails(
        processInd,
        partnerId,
        price,
        productCategoryNames,
        "",
        "",
        "",
        price,
        "",
        "",
        syfToken,
        flowType,
        mppFromAnyWhereFlag,
        childSyfPartnerId,
        partnerCode,
        childSyfMerchantNumber,
        promoOverRideFlag,
        offerNumber1,
        "",
        "",
        "",
        "",
        d2dFlow,
        merchantRefererUrl,
        partnerProfileCode || this.state.partnerProfileCode,
        siteCode,
        clientTransId,
        clientName || this.state.clientName,
        mppApplicationLink,
        authorizationNumber,
        this.state.initialCallCompleted,"","",
        syfMerchantNumber,channelId,orgFlow,acquisitionFlag,applyFromAnyWhereFlag,adobe_mcvid,this.state.payInFourProductConfigured,this.state.originUrl,
        productIds1,productIds2,productIds3
      );
      this.setState({ isFocused: true, isAmountEntryReadonly: true });
    },
    getDeviceType() === "desktop" ? 1000 : 2000
  );

  analyticsForAmountEntry = (price, error) => {
    const { merchantName, merchantNumber, syfToken, partnerId, flowType, orgPlatForm } =
      this.state;
    analyticsChangesForDynamicPriceEntry(
      merchantName,
      merchantNumber,
      syfToken,
      partnerId,
      flowType,
      price,
      error,
      orgPlatForm
    );
  };

  render() {
    const mppModalProps = {
      ...this.state,
      openApplyHandler: this.openApplyOrPrequal,
      getDevice: getDeviceType(),
      debounceCallback: this.debounceCallback,
      analyticsForAmountEntry: this.analyticsForAmountEntry,
      continueCallback: this.continueCallback,
      openPayLater: this.openPayLater,
      openSetPayIn4: this.openSetPayIn4
    };
    return (
      <div ref={this.wrapperRef} className={this.state.mppFromEmail ? "email-mpp-wrapper" : "mpp-wrapper"}>
        {console.log("isMsfApplyBuyFlow==="+this.state.isMsfApplyBuyFlow)}
        {!this.state.isPrequalified && !this.state.isDataShareTokenAvailable && (
          <ThemeContext.Provider value={mppModalProps}>
            {this.state.isMsfApplyBuyFlow == "true" ? <><MppModalHeader msfPrimaryColors={'#143D59'} /><MSFJumpScreen msfPrimaryColors={'#143D59'} mppModalProps={mppModalProps}></MSFJumpScreen></>:<MppModal />}
          </ThemeContext.Provider>
        )}
      </div>
    );
  }
}

function getOrgFlow(flowType, d2dFlow, mppFromAnyWhereFlag, isCheckoutLearnClicked,fromEmail,sc,authorizationNumber,isQuickScreenDeclined,amount,applyFromAnyWhereFlag, d2dSourceChannel, stripeFlow) {
  console.log("flow came here ", flowType, d2dFlow)
  console.log(window._SFDDL)

  //read from cookie
 
  if(isQuickScreenDeclined){
    return  amount > 0 ?"PDP-QSWidget-MPP-Widget-MPP": "PDP-QSWidget-Widget-MPP";
  }

  if(authorizationNumber){
    return "PDP-QSWidget-MPP"
  }
  if(mppFromAnyWhereFlag === 'Y'){
    return 'MPPDirect';
  }
  
  if(fromEmail === 'Y'){
    return 'EmailLink-MPP';
  }
  if(sc && sc === 'QR'){
    return 'QRlink-MPP';
  }

  if(d2dFlow && d2dFlow === 'Y'){
    switch (flowType) {
      case "PDP":
        return d2dSourceChannel === "CLOVER_PAY" ? "D2D-Clover-PDP" : "D2D-PDP";
        
      case "CHECKOUT":
        return d2dSourceChannel === "CLOVER_PAY" ? "D2D-Clover-Checkout" : "D2D-Checkout";
      
      default:
        return "D2D";
    }
  }

  if(isCheckoutLearnClicked){
    return "Checkout-Widget"; 
  }

  if (stripeFlow === "Y" && flowType === "CHECKOUT") {
    return "Checkout-Stripe-MPP";
  }

  switch (flowType) {
    case "PDP":
      return "PDP-Widget";
      
    case "CART":
      return "Cart-Widget";

    case "CHECKOUT":
      return "Checkout-MPP";

    case "MULTIWIDGET":
      return "PLP-Widget";

    case "PLP":
      return "PLP-Widget";
  }
}

function getPlacements(flowType, widgetString, isCheckoutLearnClicked, d2dFlow) {
  if(isCheckoutLearnClicked === "true"){
    return "Checkout" + widgetString;
  }

  if(d2dFlow && d2dFlow === 'Y'){
    switch (flowType) {
      case "PDP":
        return "PDP";
        
      case "CHECKOUT":
        return "Checkout";
      
      default:
        return flowType;
    }
  }

  switch (flowType) {
    case "PDP":
      return "PDP" + widgetString;

    case "CART":
      return "Cart" + widgetString;

    case "CHECKOUT":
      return "Checkout" + widgetString;

    case "MULTIWIDGET":
      return "PLP" + widgetString;

    case "PLP":
      return "PLP" + widgetString;
    
    default:
      return flowType;
  }
}

function analyticsChangesForApply(
  merchantName,
  merchantNumber,
  syfToken,
  partnerId,
  flowType,
  orgPlatForm
) {
  window._syf_._mppOffer_._SFDDL.pageInfo = {
    Country_Language: "US|ENG",
    SiteIdentifier: "digitalpos",
    CustomerType: "consumer",
    ClientName: merchantName,
    PageFunction: "Apply",
    PageName: "Apply Now",
    Device: getDeviceType(),
    PNL: "PS",
    MerchantID: merchantNumber,
    PageKind: "merchant",
    PageSubFunction: "",
    Placements: flowType,
    OfferCount: "",
    TargetName: "",
    TokenId: syfToken,
    Message: "MPP Page Learn How",
    SyfPartnerID: partnerId,
    orgPlatForm
  };

  window._syf_._mppOffer_._SFDDL.click = {
    action: "syfClickEvent",
    className: "syfClickEvent",
    "data-object": "button",
    "data-reason": "Apply",
    "data-type": "body",
  };

  window._syf_._mppOffer_._SFDDL.formAction = {
    appType: "offers_mpp",
    product: "MPP",
    action: "offer_details_page",
  };

  var event = document.createEvent("Event");
  event = new CustomEvent("syfClickEvent");
  event.initEvent("syfClickEvent");
  dispatchEvent(event);
}

function analyticsChangesForPrequalifyNow(
  merchantName,
  merchantNumber,
  syfToken,
  partnerId,
  flowType,
  orgPlatForm
) {
  window._syf_._mppOffer_._SFDDL.pageInfo = {
    Country_Language: "US|ENG",
    SiteIdentifier: "digitalpos",
    CustomerType: "consumer",
    ClientName: merchantName,
    PageFunction: "PrequalifyNow",
    PageName: "Prequalify Now",
    Device: getDeviceType(),
    PNL: "PS",
    MerchantID: merchantNumber,
    PageKind: "merchant",
    PageSubFunction: "",
    Placements: flowType,
    OfferCount: "",
    TargetName: "",
    TokenId: syfToken,
    Message: "MPP Page Learn How",
    SyfPartnerID: partnerId,
    orgPlatForm
  };
  window._syf_._mppOffer_._SFDDL.click = {
    action: "syfClickEvent",
    className: "syfClickEvent",
    "data-object": "button",
    "data-reason": "Prequalify-Now",
    "data-type": "body",
  };

  window._syf_._mppOffer_._SFDDL.formAction = {
    appType: "offers_mpp",
    product: "MPP",
    action: "offer_details_page",
  };

  var event = document.createEvent("Event");
  event = new CustomEvent("syfClickEvent");
  event.initEvent("syfClickEvent");
  dispatchEvent(event);
}

function analyticsChangesForDynamicPriceEntry(
  merchantName,
  merchantNumber,
  syfToken,
  partnerId,
  flowType,
  price,
  error,
  orgPlatForm
) {
  window._syf_._mppOffer_._SFDDL.pageInfo = {
    Country_Language: "US|ENG",
    SiteIdentifier: "digitalpos",
    CustomerType: "consumer",
    ClientName: merchantName,
    PageFunction: "dynamic_offer",
    PageName: "offer_details_page",
    Page: "MPP",
    Device: getDeviceType(),
    PNL: "PS",
    MerchantID: merchantNumber,
    PageKind: "merchant",
    PageSubFunction: "",
    Placements: flowType,
    OfferCount: "",
    TargetName: "",
    TokenId: syfToken,
    Message: "MPP Page Dynamic Amount Change",
    SyfPartnerID: partnerId,
    Price: price,
    Error: error,
    Input_Field: "Dynamic Price",
    orgPlatForm
  };

  window._syf_._mppOffer_._SFDDL.click = {
    action: "syfClickEvent",
    className: "syfClickEvent",
    "Data-Object": "input",
    "Data-Reason": "dynamic_input",
    "Data-Type": "mpp",
  };

  window._syf_._mppOffer_._SFDDL.formAction = {
    appType: "offers_mpp",
    product: "MPP",
    action: "offer_details_page",
  };

  var event = document.createEvent("Event");
  event = new CustomEvent("syfClickEvent");
  event.initEvent("syfClickEvent");
  dispatchEvent(event);
}

function analyticsChangesForMPPAnywhere(
  merchantName,
  merchantNumber,
  partnerId,
  flowType,
  syfToken,
  count,
  deviceType,
  messageType,
  orgPlatForm,
  orgFlow,
  siteCode,
  industryName,
  extendedFeatures,
  mppFromAnyWhereFlag,
  d2dToken,
  d2dSourceChannel
) {
  window._SFDDL.pageInfo = {
    ClientName: merchantName,
    Message: "MPP Page Load",
    Country_Language: "US|ENG",
    CustomerType: "consumer",
    Device: deviceType,
    MerchantID: merchantNumber,
    OfferCount: count,
    OfferType: "",
    PNL: "PS",
    PageFunction: "MPPDirect",
    PageKind: "merchant",
    PageName: "offer_details_page",
    PageSubFunction: "",
    Placements: mppFromAnyWhereFlag === "Y" ? "" : flowType,
    SiteIdentifier: "digitalpos",
    SyfPartnerID: partnerId,
    TargetName: "",
    TokenId: syfToken,
    orgChannel: "POS",
    orgFlow: getUpdatedFlow(orgFlow, "MPP"),
    orgPlatForm,
    MessageType: messageType,
    GenericTag: messageType != "" ? "Yes" : "No",
    siteCode,
    D2DToken: d2dToken || "",
    D2DsourceChannel: d2dSourceChannel || "",
    Market: industryName,
    ExtendedFeatures: extendedFeatures || ""
  };

  window._SFDDL.click = {
    action: "syfClickEvent",
    className: "syfClickEvent",
    "data-object": "button",
    "data-reason": "MPP From Anywhere",
    "data-type": "body",
  };

  window._SFDDL.formAction = {
    appType: "offers_mpp",
    product: "MPP",
    action: "offer_details_page",
  };

  var event = document.createEvent("Event");
  event = new CustomEvent("syfPageView");
  event.initEvent("syfPageView");
  dispatchEvent(event);
}


export default MppInfo;
